export const ANALYSE_HISTORY_SHOW_HISTORY_MODAL = "ANALYSE_HISTORY_SHOW_HISTORY_MODAL";
export const ANALYSE_HISTORY_HIDE_HISTORY_MODAL = "ANALYSE_HISTORY_HIDE_HISTORY_MODAL";
